import './Integrations.css';

/**
 * Official brand icons for MCP-compatible tools.
 * SVG paths sourced from Simple Icons (simpleicons.org) where available.
 */
const INTEGRATIONS = [
  {
    name: 'Claude Code & Desktop',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        {/* Claude flower/sunburst icon - Simple Icons */}
        <path d="m4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z" />
      </svg>
    ),
  },
  {
    name: 'Cursor',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        {/* Cursor logo - Simple Icons */}
        <path d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
      </svg>
    ),
  },
  {
    name: 'Windsurf',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        {/* Windsurf logo - Simple Icons */}
        <path d="M23.55 5.067c-1.2038-.002-2.1806.973-2.1806 2.1765v4.8676c0 .972-.8035 1.7594-1.7597 1.7594-.568 0-1.1352-.286-1.4718-.7659l-4.9713-7.1003c-.4125-.5896-1.0837-.941-1.8103-.941-1.1334 0-2.1533.9635-2.1533 2.153v4.8957c0 .972-.7969 1.7594-1.7596 1.7594-.57 0-1.1363-.286-1.4728-.7658L.4076 5.1598C.2822 4.9798 0 5.0688 0 5.2882v4.2452c0 .2147.0656.4228.1884.599l5.4748 7.8183c.3234.462.8006.8052 1.3509.9298 1.3771.313 2.6446-.747 2.6446-2.0977v-4.893c0-.972.7875-1.7593 1.7596-1.7593h.003a1.798 1.798 0 0 1 1.4718.7658l4.9723 7.0994c.4135.5905 1.05.941 1.8093.941 1.1587 0 2.1515-.9645 2.1515-2.153v-4.8948c0-.972.7875-1.7594 1.7596-1.7594h.194a.22.22 0 0 0 .2204-.2202v-4.622a.22.22 0 0 0-.2203-.2203Z" />
      </svg>
    ),
  },
  {
    name: 'GitHub Copilot',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        {/* GitHub Copilot logo - Simple Icons */}
        <path d="M23.922 16.992c-.861 1.495-5.859 5.023-11.922 5.023-6.063 0-11.061-3.528-11.922-5.023A.641.641 0 0 1 0 16.736v-2.869a.883.883 0 0 1 .053-.22c.372-.935 1.347-2.292 2.605-2.656.167-.429.414-1.055.644-1.517a10.098 10.098 0 0 1-.052-1.086c0-1.331.282-2.499 1.132-3.368.397-.406.89-.717 1.474-.952 1.399-1.136 3.392-2.093 6.122-2.093 2.731 0 4.767.957 6.166 2.093.584.235 1.077.546 1.474.952.85.869 1.132 2.037 1.132 3.368 0 .368-.014.733-.052 1.086.23.462.477 1.088.644 1.517 1.258.364 2.233 1.721 2.605 2.656a.883.883 0 0 1 .053.22v2.869a.641.641 0 0 1-.078.256ZM12.172 11h-.344a4.323 4.323 0 0 1-.355.508c-.77.947-1.918 1.492-3.506 1.492-1.727 0-2.991-.359-3.784-1.259-.033-.037-.063-.074-.093-.112v6.701c1.435.779 4.514 2.179 8 2.179 3.486 0 6.565-1.4 8-2.179v-6.701c-.03.038-.06.075-.093.112-.793.9-2.057 1.259-3.784 1.259-1.588 0-2.736-.545-3.506-1.492a4.323 4.323 0 0 1-.355-.508h-.18Zm4.108-4.74c-.281 0-.478.241-.597.505a1.81 1.81 0 0 0-.151.76v.674c0 .839.318 1.601.986 2.104.66.497 1.466.696 2.267.696.74 0 1.498-.218 2.057-.718.563-.505.861-1.241.861-2.013v-.743a1.81 1.81 0 0 0-.15-.76c-.12-.264-.317-.505-.598-.505zm-8.56 0c-.281 0-.478.241-.598.505a1.81 1.81 0 0 0-.15.76v.674c0 .772.298 1.508.86 2.013.56.5 1.318.718 2.058.718.801 0 1.607-.199 2.267-.696.668-.503.986-1.265.986-2.104v-.605a1.81 1.81 0 0 0-.151-.76c-.119-.264-.316-.505-.597-.505z" />
      </svg>
    ),
  },
  {
    name: 'Gemini CLI',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        {/* Google Gemini logo - Simple Icons */}
        <path d="M11.04 19.32Q12 21.51 12 24q0-2.49.93-4.68.96-2.19 2.58-3.81t3.81-2.55Q21.51 12 24 12q-2.49 0-4.68-.93a12.3 12.3 0 0 1-3.81-2.58 12.3 12.3 0 0 1-2.58-3.81Q12 2.49 12 0q0 2.49-.96 4.68-.93 2.19-2.55 3.81a12.3 12.3 0 0 1-3.81 2.58Q2.49 12 0 12q2.49 0 4.68.96 2.19.93 3.81 2.55t2.55 3.81" />
      </svg>
    ),
  },
];

/**
 * Integrations section showing supported MCP clients as an icon grid.
 */
export function Integrations() {
  return (
    <section id="integrations" className="section integrations">
      <div className="container">
        <header className="section-header">
          <h2>
            Integrates with <span className="gradient-text">Your Workflow</span>
          </h2>
          <p>Works with any MCP-compatible AI assistant.</p>
        </header>

        <div className="integrations-grid">
          {INTEGRATIONS.map((tool) => (
            <div key={tool.name} className="integration-item">
              <div className="integration-icon">{tool.icon}</div>
              <span className="integration-name">{tool.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
